import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  CssBaseline,
  FormLabel,
  Grid,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { AiFillFileUnknown, AiFillHome, AiFillPhone, AiFillSchedule } from 'react-icons/ai';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ImNotification } from 'react-icons/im';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import { HiOutlineMenuAlt2 } from 'react-icons/hi';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { MdClose, MdLanguage } from 'react-icons/md';
import { IoMdLogOut } from 'react-icons/io';
import { FaUser, FaUserCog } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { userDataFromLocal } from '../../pages/utils/getUserDetails';
import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import DialogMsg from '../DialogMsg';
import Loader from '../Loader';
import { Close } from '@mui/icons-material';

// const { GetKYCStatus } = onBoardingEkycServices;

const Header = ({ showSkip, languages, vkycStatus }) => {
  console.log('showSkipshowSkip', showSkip, vkycStatus);
  const location = useLocation();
  const navigate = useNavigate();
  console.log('location', location);
  const [open, setOpen] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);
  const [openAssist, setOpenAssist] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  const [salesCode, setSalesCode] = useState('');
  const [openloader, setOpenloader] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [dialogMsg, setDialogMsg] = useState('');
  const [validationMsg, setValidationMsg] = useState(false); // Validation error
  const [pushData, setPushData] = useState(null); // Google notification state
  // const [vkycStatus, setVkycStatus] = useState({
  //   KYC_STATUS: 'COMPLETED',
  //   VKYC_STATUS: 'PENDING'
  // });
  // const [languages, setLanguages] = useState([]);

  const userData = userDataFromLocal();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (code) => {
    console.log('code', code);
    i18next.changeLanguage(code.toLowerCase());

    setOpen(false);
    setAnchorEl(null);
  };
  const handleClickOpenLogout = () => {
    setOpenLogout(true);
  };
  const handleCloseLogout = () => {
    setOpenLogout(false);
    // setAnchorEl(null);
  };

  const handleClickOpenAssist = () => {
    if (openAssist === '') {
      setValidationMsg(true);
      return false;
    }
    // setOpenAssist(true);
    setOpenAssist(false);

    // set journey ID which is required in the end
    let existingJourney = localStorage.getItem('journey');
    existingJourney = existingJourney ? JSON.parse(existingJourney) : {};

    let newData = {};
    newData = {
      ...existingJourney,
      salesCode: salesCode
    };
    localStorage.setItem('journey', JSON.stringify(newData));
    // set journey ID which is required in the end
  };

  const openSec = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // GetKYCStatus API
  // const GetKYCStatusApi = async () => {
  //   try {
  //     const userData = userDataFromLocal();
  //     setOpenloader(true);
  //     const hdrCredential = {
  //       applicationNo: userData?.applicationNo,
  //       kycType: 'FRESH_KYC', // hardcode from by backend side as discussed with jeetu
  //       mobileNo: userData?.mobileNumber
  //     };
  //     const GetKYCStatusResponse = await GetKYCStatus(hdrCredential);
  //     if (GetKYCStatusResponse.status === 'SUCCESS') {
  //       setVkycStatus(GetKYCStatusResponse.data);
  //     } else if (GetKYCStatusResponse.status === 'error') {
  //       setDialogMsg(GetKYCStatusResponse.error);
  //       setOpenDialogeMsg(true);
  //     } else {
  //       setDialogMsg('Something went wrong');
  //       setOpenDialogeMsg(true);
  //     }
  //   } catch (error) {
  //     // console.log('errorerror', error);
  //   } finally {
  //     setOpenloader(false);
  //   }
  // };

  // Error Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
  };

  // useEffect(() => {
  //   if (location.pathname === '/in/selfregistration') {
  //     GetKYCStatusApi(); // getkycStatus to check video KYC is remaining}
  //   }
  // }, []);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setIsOpen(open);
  };

  // Google notification sidebar window
  useEffect(() => {
    console.log('Got reply from service worker:', window);
    console.log('Got reply from service worker:', 'serviceWorker' in navigator);
    console.log('Got reply from service worker:', navigator);
    if ('serviceWorker' in navigator) {
      console.log('Got reply from service worker:', window);
      // Register the service worker

      // Listen to messages from service workers
      navigator.serviceWorker.addEventListener('message', (event) => {
        console.log('Got reply from service worker:', event.data);
        try {
          const eventData = JSON.parse(event.data.notification.body);

          setPushData(eventData);
        } catch (e) {
          setPushData({ customerName: 'N/A', applicationNo: 'N/A' });
        }
        const notificationContainer = document.getElementById('pushNotification');
        notificationContainer.classList.remove('displayHidden');
      });
    } else {
      console.log("This browser doesn't support service workers");
    }
  }, []);
  const rejectCall = () => {
    const notificationContainer = document.getElementById('pushNotification');
    notificationContainer.classList.add('displayHidden');
  };
  const acceptCall = () => {
    rejectCall();
    localStorage.setItem('callToken', pushData?.token);
    localStorage.setItem('channel', pushData?.channelName);
    localStorage.setItem('vkycAppnumber', pushData.applicationNo);
    navigate(`/in/video-kyc?t=${pushData?.token}&c=${pushData?.channelNamel}`);
  };
  // Google notification function end

  return (
    <>
      {/* <CssBaseline /> */}
      <Loader openloader={openloader} />
      <Box className="headerBox">
        <Container maxWidth="lg">
          <Stack>
            <Grid container spacing={{ xs: 1, sm: 2, md: 3 }} alignContent="center">
              <Grid
                item
                // xs={location.pathname === '/in/selfregistration' ? '12' : '6'}
                xs={6}
                sm={6}
                className="headerLogoB"
              >
                {/* <img className="headerLogo" src="/static/logo/main-logo-w.svg" alt="My Logo" />{' '} */}
                <img className="headerLogo" src="/static/logo/finco-logo-w.png" alt="My Logo" />{' '}
              </Grid>
              <Grid
                item
                // xs={location.pathname === '/in/selfregistration' ? '12' : '6'}
                xs={6}
                sm={6}
                className="skipLinkB"
              >
                {location.pathname === '/in' ? (
                  showSkip ? (
                    <Link className="skipLink" to="/in/selfregistration">
                      {t('Skip')}
                    </Link>
                  ) : (
                    ''
                  )
                ) : location.pathname === '/in/selfregistration' ? (
                  // <Link className="skipLink" to="/">
                  //     language icons
                  // </Link>
                  <>
                    <Box className="headerIconB">
                      <Box display="flex" alignItems="center" className="userNoB">
                        <FaUser />
                        <Typography variant="body2" className="userNo">
                          {userData?.mobileNumber}
                          {/* {t('register')} */}
                        </Typography>
                      </Box>
                      {/* <Typography onClick={handleClickOpen} className="homeIcon">
                        <AiFillHome />
                      </Typography> */}
                      <Tooltip title={t('Assist By')}>
                        <IconButton
                          className="headerIconBtn"
                          onClick={() => setOpenAssist(true)}
                          size="small"
                        >
                          <FaUserCog />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={t('Appointment schedule')}>
                        <IconButton
                          onClick={() => navigate('/in/schedule-vkyc')}
                          size="small"
                          style={{
                            opacity:
                              vkycStatus?.KYC_STATUS === 'COMPLETED' &&
                              vkycStatus?.VKYC_STATUS === 'PENDING'
                                ? 1
                                : 0.5
                          }}
                          disabled={
                            vkycStatus?.KYC_STATUS === 'COMPLETED' &&
                            vkycStatus?.VKYC_STATUS === 'PENDING'
                              ? false
                              : true
                          }
                          className="headerIconBtn"
                        >
                          <AiFillSchedule />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={t('Call bank admin')}>
                        <IconButton
                          className="headerIconBtn"
                          onClick={() => navigate('/in/video-kyc')}
                          size="small"
                          style={{
                            opacity: vkycStatus?.KYC_STATUS === 'PENDING' ? 0.5 : 1
                          }}
                          disabled={vkycStatus?.KYC_STATUS === 'PENDING' ? true : false}
                        >
                          <AiFillPhone />
                        </IconButton>
                      </Tooltip>
                      {/* <Tooltip title="Home">
                        <IconButton onClick={handleClickOpen} size="small">
                          <Avatar sx={{ width: 32, height: 32, background: '#00bbbf' }}>
                            <AiFillHome />
                          </Avatar>
                        </IconButton>
                      </Tooltip> */}
                      <Tooltip title={t('Logout')}>
                        <IconButton
                          className="headerIconBtn"
                          onClick={handleClickOpenLogout}
                          size="small"
                          aria-controls={openSec ? 'account-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={openSec ? 'true' : undefined}
                        >
                          <IoMdLogOut />
                        </IconButton>
                      </Tooltip>
                      {/* <Typography
                        onClick={handleClickOpenLogout}
                        className="homeIcon"
                        style={{ marginLeft: '10px' }}
                      >
                        <IoMdLogOut />
                      </Typography> */}
                    </Box>
                    <Box className="drawerSmallScreen" mr={1}>
                      <Tooltip title="More Menu">
                        <IconButton onClick={toggleDrawer(true)} className="headerIconBtn">
                          <HiOutlineMenuAlt2 />
                        </IconButton>
                      </Tooltip>
                      <Drawer anchor="left" open={isOpen} onClose={toggleDrawer(false)}>
                        <Box className="drawerBox">
                          <Box className="drawerTop">
                            <Box textAlign="right" mb={2}>
                              <IconButton className="closeIconBtn" onClick={toggleDrawer(false)}>
                                <MdClose size={18} />
                              </IconButton>
                            </Box>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              className="userNoB"
                            >
                              <FaUser size={14} />
                              <Typography variant="body2" className="userNo">
                                {userData?.mobileNumber}
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            role="presentation"
                            onClick={toggleDrawer(false)}
                            onKeyDown={toggleDrawer(false)}
                          >
                            <List>
                              <ListItem
                                className="custom-list-item"
                                onClick={() => setOpenAssist(true)}
                              >
                                <Tooltip title="Assist By">
                                  <IconButton
                                    className="headerIconBtn"
                                    onClick={() => setOpenAssist(true)}
                                    size="small"
                                  >
                                    <FaUserCog size={14} />
                                  </IconButton>
                                </Tooltip>
                                <Typography variant="body2" ml={1}>
                                  Assist By
                                </Typography>
                              </ListItem>
                              <ListItem
                                className="custom-list-item"
                                onClick={() => navigate('/in/schedule-vkyc')}
                              >
                                <Tooltip title="Appointment schedule">
                                  <IconButton
                                    onClick={() => navigate('/in/schedule-vkyc')}
                                    size="small"
                                    style={{
                                      opacity:
                                        vkycStatus?.KYC_STATUS === 'COMPLETED' &&
                                        vkycStatus?.VKYC_STATUS === 'PENDING'
                                          ? 1
                                          : 0.5
                                    }}
                                    disabled={
                                      vkycStatus?.KYC_STATUS === 'COMPLETED' &&
                                      vkycStatus?.VKYC_STATUS === 'PENDING'
                                        ? false
                                        : true
                                    }
                                    className="headerIconBtn"
                                  >
                                    <AiFillSchedule size={14} />
                                  </IconButton>
                                </Tooltip>
                                <Typography
                                  variant="body2"
                                  ml={1}
                                  size="small"
                                  style={{
                                    opacity:
                                      vkycStatus?.KYC_STATUS === 'COMPLETED' &&
                                      vkycStatus?.VKYC_STATUS === 'PENDING'
                                        ? 1
                                        : 0.5
                                  }}
                                  disabled={
                                    vkycStatus?.KYC_STATUS === 'COMPLETED' &&
                                    vkycStatus?.VKYC_STATUS === 'PENDING'
                                      ? false
                                      : true
                                  }
                                >
                                  Appointment schedule
                                </Typography>
                              </ListItem>
                              <ListItem
                                className="custom-list-item"
                                onClick={() => navigate('/in/video-kyc')}
                              >
                                <Tooltip title="Call bank admin">
                                  <IconButton
                                    className="headerIconBtn"
                                    onClick={() => navigate('/in/video-kyc')}
                                    size="small"
                                    style={{
                                      opacity: vkycStatus?.KYC_STATUS === 'PENDING' ? 0.5 : 1
                                    }}
                                    disabled={vkycStatus?.KYC_STATUS === 'PENDING' ? true : false}
                                  >
                                    <AiFillPhone size={14} />
                                  </IconButton>
                                </Tooltip>
                                <Typography
                                  variant="body2"
                                  ml={1}
                                  style={{
                                    opacity: vkycStatus?.KYC_STATUS === 'PENDING' ? 0.5 : 1
                                  }}
                                  disabled={vkycStatus?.KYC_STATUS === 'PENDING' ? true : false}
                                >
                                  Call Bank Admin
                                </Typography>
                              </ListItem>
                              <ListItem
                                className="custom-list-item"
                                onClick={handleClickOpenLogout}
                              >
                                <Tooltip title="Logout">
                                  <IconButton
                                    className="headerIconBtn"
                                    onClick={handleClickOpenLogout}
                                    size="small"
                                    aria-controls={openSec ? 'account-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={openSec ? 'true' : undefined}
                                  >
                                    <IoMdLogOut size={14} />
                                  </IconButton>
                                </Tooltip>
                                <Typography variant="body2" ml={1}>
                                  Logout
                                </Typography>
                              </ListItem>
                            </List>
                          </Box>
                        </Box>
                      </Drawer>
                    </Box>
                    <div>
                      <Tooltip title={t('Click to language')}>
                        <IconButton onClick={handleClick} size="small" className="headerIconBtn">
                          <MdLanguage />
                        </IconButton>
                      </Tooltip>
                      {/* <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={openSec}
                            onClose={handleClose}
                            MenuListProps={{
                            'aria-labelledby': 'basic-button',
                            }}
                        > */}
                      <Menu
                        anchorEl={anchorEl}
                        id="account-menu"
                        open={openSec}
                        onClose={handleClose}
                        onClick={handleClose}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                      >
                        {languages.length &&
                          languages.map((item, index) => (
                            <MenuItem
                              onClick={() => handleClose(item.code)}
                              key={index}
                              style={{ fontSize: '12px', fontWeight: 'bold' }}
                              className="languageItem"
                            >
                              {item?.name}
                            </MenuItem>
                          ))}
                        {/*  just for demo, sanjay suggest to hide other languages if not done languages funcationality */}
                        {/* {languages.length &&
                          languages.map((item, index) => {
                            console.log('item3333', item);
                            if (item?.code === 'EN') {
                              return (
                                <MenuItem
                                  onClick={() => handleClose(item.code)}
                                  key={index}
                                  style={{ fontSize: '12px', fontWeight: 'bold' }}
                                >
                                  {item?.name}
                                </MenuItem>
                              );
                            } else {
                              return (
                                <MenuItem
                                  onClick={() => handleClose(item.code)}
                                  key={index}
                                  style={{ fontSize: '12px', fontWeight: 'bold' }}
                                  // disabled
                                >
                                  {item?.name}
                                </MenuItem>
                              );
                            }
                          })} */}
                        {/* <MenuItem onClick={handleClose}>
                        <img src="/static/flag/thaiSmall.svg" alt="Thai Language" />
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <img src="/static/flag/englishSmall.svg" alt="English Language" />
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <img src="/static/flag/chineseSmall.svg" alt="Chinese Language" />
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <img src="/static/flag/myanmarSmall.svg" alt="Myanmar Language" />
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <img src="/static/flag/cambodiaSmall.svg" alt="Cambodia Language" />
                      </MenuItem> */}
                      </Menu>
                    </div>
                  </>
                ) : location.pathname === '/in/document-choose' ||
                  location.pathname === '/in/document-photo' ||
                  location.pathname === '/in/document-with-selfie' ||
                  location.pathname === '/in/face-selfie' ||
                  location.pathname === '/in/personal-info' ||
                  location.pathname === '/in/schedule-vkyc' ||
                  location.pathname === '/in/video-kyc' ||
                  location.pathname === '/in/thanks' ||
                  location.pathname === '/in/contact' ||
                  location.pathname === '/in/registration-result' ||
                  location.pathname === '/in/registration-successful' ? (
                  // <Typography onClick={handleClickOpen} className="homeIcon">
                  //   <AiFillHome />
                  // </Typography>
                  <Tooltip title={t('Home')}>
                    <IconButton onClick={handleClickOpen} size="small" className="headerIconBtn">
                      <AiFillHome />
                    </IconButton>
                  </Tooltip>
                ) : (
                  ''
                )}
              </Grid>
            </Grid>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              className="popupBlue"
            >
              <DialogTitle id="alert-dialog-title" className="popupBlueHeading">
                <Box className="popupIconBox">
                  <ImNotification className="popupIcon" />
                </Box>
                <Typography variant="subtitle1" color="white">
                  {t('Please Confirm')}
                </Typography>
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText id="alert-dialog-description" className="popupBody">
                  {/* <Typography variant="subtitle1" className="popUpHeading" mb={2}>
                    Title
                  </Typography> */}
                  <Typography variant="body2" className="popupContent" mt={2}>
                    {t(
                      'In case of cancellation the registration process must be done from the beginning'
                    )}
                  </Typography>
                </DialogContentText>
              </DialogContent>
              <DialogActions className="popupFooter">
                <Link
                  variant="contained"
                  className="mainBtn"
                  color="primary"
                  to="/in/selfregistration"
                  onClick={handleClose}
                >
                  {t('Confirm')}
                </Link>
                <Link
                  className="mainBtn"
                  variant="contained"
                  color="secondary"
                  onClick={handleClose}
                  autoFocus
                >
                  {t('Cancel')}
                </Link>
              </DialogActions>
            </Dialog>
            <Dialog
              open={openLogout}
              onClose={handleCloseLogout}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              className="popupBlue"
            >
              <DialogTitle id="alert-dialog-title" className="popupBlueHeading">
                <Box className="popupIconBox">
                  <ImNotification className="popupIcon" />
                </Box>
                <Typography variant="subtitle1" color="white">
                  {t('Alert')}
                </Typography>
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText id="alert-dialog-description" className="popupBody">
                  {/* <Typography variant="subtitle1" className="popUpHeading" mb={2}>
                    Title
                  </Typography> */}
                  <Typography variant="body1" textAlign="center" className="popupContent" mt={3}>
                    {t('Are you sure, You want to logout')}
                  </Typography>
                </DialogContentText>
              </DialogContent>
              <DialogActions className="popupFooter">
                <Link
                  variant="contained"
                  className="mainBtn"
                  color="primary"
                  to="/"
                  onClick={handleCloseLogout}
                >
                  {t('Logout')}
                </Link>
                <Link
                  className="mainBtn"
                  variant="contained"
                  color="secondary"
                  onClick={handleCloseLogout}
                  autoFocus
                >
                  {t('Cancel')}
                </Link>
              </DialogActions>
            </Dialog>
          </Stack>

          <Dialog open={openAssist} onClose={handleCloseLogout} className="popupBlue">
            <DialogTitle className="dialog-title" style={{ textAlign: 'center' }}>
              <Typography variant="subtitle1">{t('Enter Sales Code')}</Typography>
              <IconButton onClick={() => setOpenAssist(false)} size="small">
                <Close />
              </IconButton>
            </DialogTitle>

            <DialogContent dividers>
              <DialogContentText id="alert-dialog-description" className="popupBody">
                {/* <Typography variant="subtitle1" className="popUpHeading" mb={2}>
                    Title
                  </Typography> */}
                {/* <Typography variant="body1" className="popupContent">
                  Please enter the sales code to provide further details
                </Typography> */}

                <Typography variant="body2" mb={1} className="FormLabel">
                  <FormLabel>
                    {t('Please enter the sales code to provide further details')}
                  </FormLabel>
                </Typography>
                <TextField
                  fullWidth
                  type="text"
                  className="frmHelperAlign"
                  inputProps={{
                    className: 'formControl'
                  }}
                  placeholder={t('Code')}
                  value={salesCode}
                  onChange={(e) => setSalesCode(e.target.value)}
                  error={salesCode === '' ? validationMsg : false}
                  helperText={
                    (salesCode === undefined || salesCode === '') && validationMsg === true
                      ? t('Please enter sales code')
                      : ''
                  }
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions className="dialogFooter">
              <Button
                variant="contained"
                className="mainBtn"
                color="primary"
                onClick={handleClickOpenAssist}
              >
                {t('Enter')}
              </Button>
              <Link
                className="mainBtn"
                variant="contained"
                color="secondary"
                onClick={() => setOpenAssist(false)}
                autoFocus
              >
                {t('Cancel')}
              </Link>
            </DialogActions>
          </Dialog>

          {/* <DialogMsg
            openDialogeMsg={openDialogeMsg}
            dialogMsg={dialogMsg}
            dialogTitle="Alert"
            buttonText="Close"
            closeDialogMsgHandler={closeDialogMsgHandler}
          /> */}
        </Container>
      </Box>
      {/* Notification when comes */}
      <Box id="pushNotification" className="pushNotification displayHidden">
        <Box class="notification-container">
          <Box class="notification">
            <Box class="notification-header">
              {pushData && pushData.customerName} VKYC Call
              <span class="close-btn" onClick={rejectCall}>
                &times;
              </span>
            </Box>
            <Box class="notification-body">
              <Stack style={{ marginBottom: '10px' }}>
                <b>Application No:</b>
                <p>{pushData && pushData.applicationNo}</p>
              </Stack>
              <Stack style={{ width: '100%', textAlign: 'right', display: 'block' }}>
                <button class="answer-btn" onClick={() => acceptCall(pushData)}>
                  Answer
                </button>
                <button class="reject-btn" onClick={rejectCall}>
                  Reject
                </button>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Header;
